import { PaymentTablesColumns } from './components/tables/types';
import prefix from './prefix';

export const NEW_CREDIT_CARD_VALUE = 'newCreditCard';
export const PAYMENT_TERMINAL_COMMAND_CREATE = prefix('COMMAND_CREATE');
export const UPDATE_PREAUTHORIZATION = prefix('UPDATE_PREAUTHORIZATION');
export const REFUND_PAYMENT = prefix('REFUND_PAYMENT');

export const MAX_PREAUTHORIZATION_EXPIRATION_DAYS = 28;
export const PREAUTHORIZATION_TYPE = 'Preauthorization';

export const PAYMENTS_LIMIT = 5000;

export const PAYMENTS_TABLE_COLUMNS = Object.values(PaymentTablesColumns);
